import axios from 'axios'
import { BASE_URL, JWT_APP_ID } from '../../config/URL'

export const beginTransaction = ({ type, packageId}) => async (dispatch, getState) => {
  const state = getState()
  const res = await axios.post(
    `${BASE_URL}/subscription/v1.1/transactions`, 
    { type, packageId }, 
    {
      headers: {
        Authorization: state.auth.token,
        'Cloudfront-JWT-AppId': JWT_APP_ID
      } 
    }
  )
  return res.data
}
